import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchMainPageInfo } from 'modules/main/store/main-page/actions';
import { TEAM_DEFAULT_LOGO, USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { toApiError } from 'shared/errors';
import type { MainPageSliceState } from './main-page-store';

type ReducerBuilder = ActionReducerMapBuilder<MainPageSliceState>;

export function createFetchChampionshipsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchMainPageInfo.pending, (state) => {
    // повторный заход на дашборд — обновляем в фоне, не сбрасывая уже показанные данные
    if (state.status.loaded) {
      state.status.refreshing = true;
    } else {
      state.status.loading = true;
    }
    state.status.error = null;
  });

  builder.addCase(fetchMainPageInfo.fulfilled, (state, action) => {
    state.status.loading = false;
    state.status.refreshing = false;
    state.status.loaded = true;
    state.status.error = null;

    state.tournamentId = action.meta.arg.tournamentId;
    const payload = action.payload;

    state.totalChampionships = payload.championships ?? 0;
    state.championships = {
      ended: payload.finishedChampionships ?? 0,
      preparing: payload.upcomingChampionships ?? 0,
      stared: payload.activeChampionships ?? 0,
    };

    state.teams = {
      total: payload.teams ?? 0,
      declared: payload.acceptedApplicationsTeams ?? 0,
      popular:
        payload.topTeams?.map((team) => ({
          id: team.team?.id ?? 0,
          name: team.team?.name ?? '',
          image: team.team?.emblem?.externalUrl ?? TEAM_DEFAULT_LOGO,
          matchCount: team.matchCount ?? 0,
        })) ?? [],
    };

    state.players = {
      total: payload.players ?? 0,
      declared: payload.acceptedApplicationsPlayers ?? 0,
      bestScorers:
        payload.topShooters?.map((shooter) => ({
          id: shooter.user?.id ?? 0,
          name: (shooter.user?.surname ?? '') + ' ' + (shooter.user?.name ?? ''),
          goals: shooter.goals ?? 0,
          image: shooter.user?.photo?.externalUrl ?? USER_DEFAULT_AVATAR,
        })) ?? [],
    };
  });

  builder.addCase(fetchMainPageInfo.rejected, (state, action) => {
    state.status.loading = false;
    state.status.refreshing = false;
    state.status.error = toApiError(action.payload ?? action.error).message || null;
  });
}
